export const FAQS = [
  {
    title: "What industries benefit from Managed Services?",
    content:
      "Industries such as finance, healthcare, retail, and manufacturing benefit from managed services due to the need for strict security, compliance, and uptime reliability.",
  },
  {
    title: "Can Unmanaged Services still provide security options?",
    content:
      "Yes, but businesses must implement firewalls, endpoint protection, backups, and network monitoring independently.",
  },
  {
    title: "How does Co-managed Services improve IT efficiency?",
    content:
      "Co-managed services allow organizations to outsource routine maintenance, security monitoring, or compliance while maintaining control over business-critical IT functions.",
  },
  {
    title: "Is Managed IT more expensive than Unmanaged IT?",
    content:
      "Initially, managed services appear more costly, but they reduce expenses in downtime, security risks, compliance failures, and IT staffing.",
  },
  {
    title: "What are the risks of choosing Unmanaged Services?",
    content:
      "Without proper IT expertise, unmanaged services can lead to downtime, misconfigurations, security vulnerabilities, and compliance risks.",
  },
  {
    title: "Can Co-managed Services help with Cloud Migration?",
    content:
      "Yes, co-managed service providers often assist with cloud migration, hybrid cloud management, and workload balancing.",
  },
  {
    title: "Do Managed Services include disaster recovery solutions?",
    content:
      "Most MSPs provide disaster recovery, backups, and failover solutions to prevent data loss and downtime.",
  },
  {
    title: "Can a business switch from Unmanaged to Managed Services later?",
    content:
      "Yes! Businesses can transition from unmanaged to managed services as their needs evolve.",
  },
  {
    title: "How does Managed Services ensure compliance?",
    content:
      "MSPs ensure GDPR, HIPAA, PCI-DSS, and ISO 27001 compliance by managing security, audits, and policy enforcement.",
  },
  {
    title: "What level of support is included in Co-managed Services?",
    content:
      "Support levels vary, but co-managed services often provide 24/7 monitoring, cybersecurity, and expert consulting while allowing internal IT teams to handle strategic decision-making.",
  },
  {
    title: "How do Managed Services handle software updates?",
    content:
      "MSPs automate patching and updates, ensuring systems remain secure and up to date without manual intervention.",
  },
  {
    title: "What’s the difference between Co-managed IT and IT Outsourcing?",
    content:
      "Co-managed IT is a partnership where IT management is shared, while full IT outsourcing transfers 100% control to an MSP.",
  },
];
